import React from 'react';
import './Common.css';

/**
 * ErrorMessage component for displaying error messages
 * 
 * @param {Object} props
 * @param {string} props.message - Error message to display
 * @param {string} props.type - Type of error (warning, error, info)
 * @param {string} props.className - Additional class name for styling
 * @returns {JSX.Element}
 */
const ErrorMessage = ({ 
  message,
  type = 'error',
  className = '',
  ...restProps 
}) => {
  if (!message) return null;
  
  return (
    <div 
      className={`error-message error-${type} ${className}`}
      role="alert"
      {...restProps}
    >
      {message}
    </div>
  );
};

export default ErrorMessage; 